import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GeAccountLoader from './Loader/GeAccountLoader';
import { faEnvelope, faUsersCog } from '@fortawesome/free-solid-svg-icons';
import './styles.scss';
import { withTranslation } from 'react-i18next';
import { PulseLoader } from 'react-spinners';

class GeAccount extends Component {

  componentDidMount() {
    this.props.getProfileDetails();
  }

  renderAccountInfo = () => {
    let { fieldValue, isProfileDetailsLoading } = this.props.profile;
    const { t } = this.props;
    let fieldValueDetails = fieldValue ? fieldValue.emailId : '';

    if (isProfileDetailsLoading) 
      return (
        <GeAccountLoader />
      ) 
    else
      return (
        <div className="account-information-wrapper">
          <div className="account-details">
            <div className="account-logo">
              <p className="account-initial">
                {this.setProfileDetails()}
              </p>
            </div>
            <div className="details-wrapper">
              <div className="details-info">
                <FontAwesomeIcon icon={faEnvelope} color={'#D7D8DB'} />
                <p className="details-text">
                  {fieldValueDetails}
                </p>
              </div>
              <div className="details-info">
                <FontAwesomeIcon icon={faUsersCog} color={'#D7D8DB'} />
                <p className="details-text">{t('gehcUser')}</p>
              </div>
            </div>
          </div>
        </div>
      )
  }

  render() {
    const { t } = this.props;

    return (
      <div className="ge-account-view-wrapper">
        {this.props.generic.initialLoad ? <div className='init-loader'><PulseLoader color={'#ffffff'} style={{ marginBottom: 24, marginTop: 24 }} /></div> : <>
        <div className="account-desktop-wrapper">
          <div className="account-details-wrapper">
            <div className="account-title">{t('account')}</div>
          </div>
        </div>
        {this.renderAccountInfo()}
        </>
        }
      </div>
    );
  }

  setProfileDetails = () =>{
    let { profileDetails} = this.props.profile;
    let profileName = '';
    if(profileDetails)
    {
      if(profileDetails.firstName)
      {
        profileName = profileDetails.firstName.charAt(0);
      }
      if(profileDetails.lastName)
      {
        profileName = profileName + profileDetails.lastName.charAt(0);
      }
      else
      {
        profileName = profileName + '';
      }
    }
    return profileName;
  }
}

export default withTranslation()((GeAccount));
